import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'item']
  static values = {
    maxDisplayed: { type: Number, default: Infinity }
  }

  connect() {
    this.filterItems()
  }

  filterItems() {
    this.#hideAllItems()
    this.#showMatchingItemsWithinMax()
  }

  clearInput() {
    this.inputTarget.value = ''
    this.inputTarget.dispatchEvent(new Event('input')) // run input handler
  }

  #hide(item) {
    item.classList.add('hidden')
  }

  #show(item) {
    item.classList.remove('hidden')
  }

  #showMatchingItemsWithinMax() {
    this.matchingItems
      .slice(0, this.maxDisplayedValue)
      .forEach((item) => this.#show(item))
  }

  #hideAllItems() {
    this.itemTargets.forEach((item) => this.#hide(item))
  }

  get searchTerm() {
    return this.inputTarget.value.toLowerCase().trim()
  }

  get matchingItems() {
    return this.itemTargets.filter((item) =>
      item.textContent.toLowerCase().includes(this.searchTerm)
    )
  }
}
